export const TOGGLE_APPOINTMENT_MODAL = 'TOGGLE_APPOINTMENT_MODAL';
export const TOGGLE_CONTACT_MODAL = 'TOGGLE_CONTACT_MODAL';
export const TOGGLE_CONTACT_SUCCESS_ALERT = 'TOGGLE_CONTACT_SUCCESS_ALERT';
export const UPDATE_WINDOW_SIZE = 'UPDATE_WINDOW_SIZE';
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';